import { Injectable } from '@angular/core';
import {L10nTranslationService} from "angular-l10n";


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private translation: L10nTranslationService,) { }
  isMobile = false;
  sideMenuOpen = false;
  showShadow = false;
  currentLanguage:string = 'en'
  language: string = 'en-US'

  getCurrentLanguage(): string {
    const lang = localStorage.getItem('lang');

    if (lang) {
      this.currentLanguage = lang;
    } else {
      localStorage.setItem('lang', this.currentLanguage);
    }

    this.setCurrentLanguage();
    return this.currentLanguage;   // ✅ VERY IMPORTANT
  }

  updateLanguage() {
    if(this.currentLanguage === 'en') {
      this.currentLanguage = 'ar'
    } else {
      this.currentLanguage = 'en'
    }
    (window as any).APP_LANG = this.currentLanguage;

    if ((window as any).switchChatLanguage) {
      (window as any).switchChatLanguage(this.currentLanguage);
    }
    localStorage.setItem('lang', this.currentLanguage)
    this.setCurrentLanguage()
  }

  setCurrentLanguage() {
    if(this.currentLanguage === 'en') {
      this.language = 'en-US'
    } else {
      this.language =  'ar-SA'
    }
    const locale = {
      language: this.language
    }
    this.translation.setLocale(locale);
    if (this.currentLanguage === 'ar') {
      document.body.style.direction = 'rtl';
      document.body.classList.add('ar');
      document.dir = 'rtl';

    } else {
      document.body.style.direction = 'ltr';
      document.body.classList.add('en');
      document.dir = 'ltr';
    }
  }
  toggleSideMenu () {
    this.sideMenuOpen = !this.sideMenuOpen
    this.showShadow = !this.showShadow
    this.showShadow ? document.body.style.overflow = "hidden" :  document.body.style.overflow = "scroll"

  }

  resize() {
    this.isMobile = window.innerWidth <= 768;

  }


   loadScript(url: string) {
     for (let i = 0; i < document.scripts.length; i++){
       if(url === (document.scripts[i].src)) {
         const scriptsList = document.scripts  as any
         scriptsList[i].remove()
         break

       }
     }
     let node = document.createElement('script');
     node.src = url;
     document.getElementsByTagName('head')[0].appendChild(node);

   }
}
